import React from 'react';
import PropTypes from 'prop-types';
import Item from './Item';
import parseDate from 'date-fns/parse';
import formatDate from 'date-fns/format';
import {
  underscoreToTitleCase
} from 'utils/strings';

const styles = {
  outer: {
    marginBottom: '10px'
  }
};

const parseAndFormatDate = (date, _default, format = 'DD/MM/YYYY') => {
  if (!date) {
    return _default;
  }

  return formatDate(parseDate(date), format);
};

const ClaimDetails = ({
  claimNumber,
  state,
  openedAt,
  closedAt,
  outcome,
  outcomeMessage
}) => (
  <div style={styles.outer}>
    <Item key="claim-number" heading="Claim Number" content={claimNumber} />
    <Item key="state" heading="State" content={underscoreToTitleCase(state)} />
    <Item key="opened-at" heading="Opened At" content={parseAndFormatDate(openedAt)} />
    <Item key="closed-at" heading="Closed At" content={parseAndFormatDate(closedAt, 'Open')} />
    {outcome && <Item key="outcome" heading="Outcome" content={outcome} />}
    {outcomeMessage && <Item key="outcome-message" heading="Details" content={outcomeMessage} />}
  </div>
);

ClaimDetails.propTypes = {
  claimNumber: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  openedAt: PropTypes.string.isRequired,
  closedAt: PropTypes.string,
  outcome: PropTypes.string,
  outcomeMessage: PropTypes.string,
};

export default ClaimDetails;



// WEBPACK FOOTER //
// ./src/components/Query/QueryShow/ClaimDetails.js